import { deleteLrFromTripApi, deletePodImage, getAllBranchDropdwon, getAllDriver, getAllSupplier, getLastTrip, handleKeyDown, podReceivedData, podStatusUpdateData, updateTripApi } from "_services";
import { CommonDatePicker, CommonInput, CustomSelect } from "components";
import { Images } from "constants";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import {
  AddEditLrModal,
  AddEditMarketDriver,
  AddEditOwnDriver,
  AddLrModal,
  AtPartyPointModal,
  ConfirmModalFor,
  ContinuePodRecievedModal,
  EbillExtentionModal,
  EditPodStatus,
  EditTripModal,
  EditTripOffCanvas,
  EndTripModal,
  LrDetailModal,
  MakeTruckAvailableModal,
  PodRecievedModal,
  SelectLrForConsignor,
  SelectLrModal2,
} from "modals";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import LoadingChalli from "./LoadingChalli";
import SingleSelectDropdownInfinite from "components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite";
import { TripDetail } from ".";
import AddEditSupplier from "modals/AddEditSupplier";
import './dispatch.css'
import { fetchConsignorDetailsData } from "_services/accountsServices/consignorServices";
import { actionPermission } from "helper";
import { constant } from "constants/constant";
import { getDataLrDetails } from "_services/accountsServices/lrServices";
import images from "constants/images";
import { addEwayWill } from "features";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import AddPickUpDrop from "modals/AddPickUpDrop/AddPickUpDrop";
import AddEditConsignor from "modals/AddEditConsignor/AddEditConsignor";
import FirmImg from '../../assets/img/firm.png'
import CrossCompanyFreightAlert from "./CrossCompanyFreightAlert";



const DispatchDetails = ({
  freightId,
  tripDetais,
  callApi,
  showOffEditOfcanvas,
  setShowEditOfcanvas,
  tripUpdateLoading,
  setTripUpdateLoading
}) => {
  const intialForm = {
    company_id: StorageService.getCompanyId(),
    branch_id: "",
    dispatch_date: "",
    driver_id: "",
    supplier_id: "",
    vehicle_type_id: "",
    lorry_type_id: "",
    vehicle_id: "",
    start_kms: 0,
    end_kms: 0,
    route_name: "",
    lr_list: [],
    from_location: [],
    to_location: [],
    location: [],
  };

  const initiFrom = {
    from_city: "",
    from_state: "",
    lat: "",
    long: "",
    status: 1,
  };

  const initiTo = {
    to_city: "",
    to_state: "",
    lat: "",
    long: "",
    status: 1,
  };

  const ewayinit = {
    eway_bill_number: "",
    start_date: new Date(),
    end_date: new Date(),
  };


  const arryOptions = [
    { label: "Arjun", value: "01" },
    { label: "Anvit", value: "02" },
  ];
  const { masterData, globTripDetails, cities } = useContext(UserContext);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [data, setData] = useState(tripDetais);
  const [fromLoction, setFromLoction] = useState([initiFrom]);
  const [toLoction, setToLoction] = useState([initiTo]);
  const [form, setForm] = useState(intialForm);
  const [initialData, setInitialData] = useState(intialForm);
  const {
    loading: ewayLoading,
    error,

  } = useSelector((state) => state.trip);
  const [divCount, setDivCount] = useState(1);
  const [tripTable, setTripTable] = useState([]);
  const [listOfLr, setListOfLr] = useState([{ list: [] }]);
  const [isOpenSmallModal, setIsOpenSmallModal] = useState(false);
  const [textState, setTextState] = useState(0);
  const [showEndTrip, setShowEndTrip] = useState(false);
  const [showAvailableTruck, setShowAvailableTruck] = useState(false);
  const [showLrDetail, setShowLrDetail] = useState(false);
  const [showAddLR, setShowAddLR] = useState(false);
  const [challiValues, setChalliValues] = useState([]);
  const [challiDisable, setchalliDisable] = useState(true);
  // const [tripUpdateLoading, setTripUpdateLoading] = useState(false)
  const [formError, setFormError] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [showOffcanvasDriver, setShowOffcanvasDriver] = useState(false)
  const [showOffcanvasOwnDriver, setShowOffcanvasOwnDriver] = useState(false)
  const [showOffcanvasSupplier, setShowOffcanvasSupplier] = useState(false)
  const [listOfLr2, setListOfLr2] = useState([]);
  const [consignorLoading, setConsignorLoading] = useState({})
  const [loading, setLoading] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    messageType: null,
    templateId: null,
    templateData: {},
    isLoading: false,
  });

  const [isOpenPodReceived, setIsOpenPodReceived] = useState(false);
  const [continePodReceived, setContinePodReceived] = useState(false);
  const [isPodStatusEdit, setIsPodStatusEdit] = useState(false);
  const [consignorDetailsData, setConsignorDetailsData] = useState({});
  const [deletePodFiles, setDeletePodFiles] = useState({});
  const [ewaybillShow, setEwaybillShow] = useState(false);
  const [ewayBillId, setEwayBillId] = useState("");
  const [ewayForm, setEwayForm] = useState(ewayinit);
  // const [showOffEditOfcanvas, setShowEditOfcanvas] = useState(false);
  const [showEditTrip, setShowEditTrip] = useState({
    isOpen: false,
    type: ""
  });
  const [selectParty, setSelectParty] = useState(false);
  const [showPrefield, setShowingPrefield] = useState(false);
  const [isAddConsignor, setIsAddConsignor] = useState(false);
  const [isPickupDrop, setIsPickupDrop] = useState(false)
  const [showSelectLr, setShowSelectLr] = useState(false);
  const [isAddLrLater, setIsAddLrLater] = useState(false);
  const [selectedLr, setSelectedLr] = useState([]);
  const [isSelectLR, setIsSelectLR] = useState(false);
  const [lrId, setLrId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);



  const getOwnerShip = tripDetais?.vehicle_id?.vehicle_ownership
  const driverPermmission = tripDetais?.branch_id?.market_drive_on_dispatch?.view
  const driverType = tripDetais?.vehicle_ownership == 2 ? 2 : 1;
  const tripOwnerShip = tripDetais?.vehicle_ownership

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {

    setForm({
      ...form,

      branch_id: {
        ...tripDetais?.branch_id,
        name: tripDetais?.branch_id?.branch,
        label: tripDetais?.branch_id?.branch,
        value: tripDetais?.branch_id?._id,
      },
      // dispatch_date: utils.convertISOToReadableFormat(tripDetais?.dispatch_date),
      dispatch_date: new Date(tripDetais?.dispatch_date),

      route_name: { label: tripDetais?.route_name, value: "" },
      vehicle_id: {
        label: `${tripDetais?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[tripDetais?.vehicle_ownership]
          }`,
        value: tripDetais?.vehicle_id?._id,
      },
      vehicle_type_id: {
        label: `${tripDetais?.lorry_type_id?.lorry_type} > ${tripDetais?.vehicle_type_id?.name}`,
        value: tripDetais?.vehicle_type_id?._id,
      },
      supplier_id: { ...tripDetais?.supplier_id, label: tripDetais?.supplier_id?.name, value: tripDetais?.supplier_id?._id },

      driver_id: { ...tripDetais?.driver_id, label: tripDetais?.driver_id?.name, value: tripDetais?.driver_id?._id },
      start_kms: tripDetais?.start_kms ? tripDetais?.start_kms : 0,
      end_kms: tripDetais?.end_kms ? tripDetais?.end_kms : 0,
      loading_challi: {
        responses: tripDetais?.loading_challi
      }
    });

    setInitialData({
      ...initialData,

      branch_id: {
        ...tripDetais?.branch_id,
        name: tripDetais?.branch_id?.branch,
        label: tripDetais?.branch_id?.branch,
        value: tripDetais?.branch_id?._id,
      },
      // dispatch_date: utils.convertISOToReadableFormat(tripDetais?.dispatch_date),
      dispatch_date: new Date(tripDetais?.dispatch_date),

      route_name: { label: tripDetais?.route_name, value: "" },
      vehicle_id: {
        label: `${tripDetais?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[tripDetais?.vehicle_ownership]
          }`,
        value: tripDetais?.vehicle_id?._id,
      },
      vehicle_type_id: {
        label: `${tripDetais?.lorry_type_id?.lorry_type} > ${tripDetais?.vehicle_type_id?.name}`,
        value: tripDetais?.vehicle_type_id?._id,
      },
      supplier_id: { ...tripDetais?.supplier_id, label: tripDetais?.supplier_id?.name, value: tripDetais?.supplier_id?._id },

      driver_id: { ...tripDetais?.driver_id, label: tripDetais?.driver_id?.name, value: tripDetais?.driver_id?._id },
      start_kms: tripDetais?.start_kms ? tripDetais?.start_kms : 0,
      end_kms: tripDetais?.end_kms ? tripDetais?.end_kms : 0,
      loading_challi: {
        responses: tripDetais?.loading_challi
      }
    })

    setChalliValues(tripDetais?.loading_challi)

    setFromLoction(tripDetais?.from_location);

    const flatLrs = tripDetais.to_location.flatMap(loc =>
      loc.lr_list.map(lr => ({
        ...lr
      }))
    );

    

    setListOfLr2(flatLrs)

  }, [tripDetais]);

  const getConsignorDetails = async (e, data, index, type) => {
    e.stopPropagation()
    const key = `${type}_${index}`;
    setConsignorLoading(prev => ({ ...prev, [key]: true }));
    // setIndexOfLr(index)
    try {
      let object = {
        consignor_id: data?.consignor_id?._id,
        company_id: StorageService.getCompanyId(),
      }
      const res = await fetchConsignorDetailsData(object);
      if (!!res) {
        if (!!data?._id) {
          setShowAddLR({ ...res?.data?.consignor, lr_id: data?._id, isEditLr: true })
        } else {
          setShowAddLR({ ...res?.data?.consignor })
        }
      } else {
        setLoading(false);
      }
    } catch (error) {

    } finally {
      setConsignorLoading(prev => ({ ...prev, [key]: false }));

    }

  }

  const getDetailsOfConsignorData = async (data) => {
    try {
      let object = {
        consignor_id: data?.consignor_id?._id ? data?.consignor_id?._id : data?.consignor_id,
        company_id: data?.company_id ? data?.company_id : StorageService?.getCompanyId(),
      }
      const res = await fetchConsignorDetailsData(object);
      if (!!res) {
        setLoading(false);
        setConsignorDetailsData(res?.data?.consignor);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (isOpenPodReceived || isPodStatusEdit) {
      setLoading(true);
      getDetailsOfConsignorData(isOpenPodReceived || isPodStatusEdit);
    }
  }, [isOpenPodReceived, isPodStatusEdit])
  useEffect(() => {

    if (tripDetais) {
      tripDetais?.from_location?.map((user) => addFromInput());
      tripDetais?.to_location?.map((user) => {
        setToLoction([...toLoction, initiTo]);
        setListOfLr([...listOfLr, { list: [] }]);
        setDivCount(tripDetais?.to_location.length);
      });

      setFromLoction(
        tripDetais?.from_location?.map((user) => {
          return {
            ...user,
            label: `${user.from_city}, ${user?.from_state}`,
            value: `${user.from_city}, ${user?.from_state}`,
          };
        })
      );

      setToLoction((pre) => {
        const modifyData = tripDetais?.to_location?.map((user) => {
          return {
            ...user,
            label: `${user.to_city}, ${user?.to_state}`,
            value: `${user.to_city}, ${user?.to_state}`,
          };
        });

        // Extract all lr_list items where they exist
        const newarray = modifyData.map((i) => i?.lr_list ? [...i.lr_list] : []);

        const mergedArray1 = newarray.flat();

        // Group by to_location and to_state from lr_list items
        const groupedByToLocation = mergedArray1.reduce((acc, item) => {
          const key = `${item.to_location}, ${item.to_state}` || "Unknown";

          if (!acc[key]) {
            acc[key] = [];
          }

          acc[key].push(item);
          return acc;
        }, {});

        // Start with all original locations
        const groupedArray = modifyData.map((original) => {
          const key = `${original.to_city}, ${original.to_state}`;

          return {
            ...original,
            to_location: key,
            lr_list: groupedByToLocation[key] || [], // Use grouped data if exists, otherwise empty array
          };
        });

        return groupedArray;
      });
    }
  }, [tripDetais]);




  const handleChalliChange = async (values) => {
    setChalliValues(values);
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          loadingChalliMandatory: Number(tripDetais?.branch_id?.loading_challi?.mandatory) || 0,
          loadingChalli: values,

        },
        errorSchema.createTripUpdateSchima
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };


  const addFromInput = (e) => {
    setFromLoction((preState) => {
      return [...preState, initiFrom];
    });
  };

  const handleButtonText = (status, type) => {
    switch (status) {
      case 1:
        return "Mark Document Ready";
      case 2:
        return "Intransit";
      case 3:
        return "At Party Point";
      case 4:
        return "Delivered";
      case 5:
        return "Raise Bill";
      case 6:
        return "Completed";

      default:
        break;
    }
  };

  const submitTestHandle = (status) => {
    switch (status) {
      case 1:
        return "Mark Document Ready";
      case 2:
        return "Intransit";
      case 3:
        return "At Party Point";
      case 4:
        return "Delivered";
      case 5:
        return "Raise Bill";

      default:
        return "Completed";
        break;
    }
  };

  const handleButtonClick = (status, tripDetais) => {


    switch (status?.lr_status) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 6:
        setIsOpenSmallModal(status);
        setTextState(status);
        break;

      case 5:
        navigate("/invoicing/createbillraise", {
          state: {
            consignor: status?.consignor_id,
            branch: tripDetais?.branch_id,
          },
        });
        break;

      default:
        break;
    }
  };



  const callBackApiCall = (status) => {
    if (status) {
      callApi(status);
    }
  };

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  };

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);

  };

  const editLoadChali = () => {
    setchalliDisable(false)
  }

  const onhandleChange = async (item, name) => {
    const stateObj = { ...form, [name]: item };
    setForm(stateObj);

    const validationResult = await utils.checkFormError(
      {
        branch: stateObj?.branch_id,
        driver: stateObj?.driver_id,
        supplier: stateObj?.supplier_id,
      },
      errorSchema.createTripUpdateSchima
    );
    if (validationResult === true) {
      setFormError("");
    } else {
      setFormError(validationResult);
    }
    if (formError[name] && item) {
      const updatedErrors = { ...formError };
      delete updatedErrors[name];
      setFormError(updatedErrors);
    }

  };

  const handleUpdateTrip = async () => {
    setTripUpdateLoading(true)

    const validationResult = await utils.checkFormError(
      {
        ...form,
        addDriverMandatory: tripOwnerShip == 2 ? Number(tripDetais?.branch_id?.market_drive_on_dispatch?.mandatory) || 0 : 0,
        loadingChalliMandatory: Number(tripDetais?.branch_id?.loading_challi?.mandatory) || 0,
        loadingChalli: challiValues,

      },
      errorSchema.createTripUpdateSchima
    );

    const updatedFields = {};

    if (form?.branch_id?._id !== initialData?.branch_id?._id) {
      updatedFields.branch_id = form?.branch_id?._id;
    }
    if (form?.driver_id?._id !== initialData?.driver_id?._id) {
      updatedFields.driver_id = form?.driver_id?._id;
      updatedFields.is_existing_driver = 1
    }
    if (form?.supplier_id?._id !== initialData?.supplier_id?._id) {
      updatedFields.supplier_id = form?.supplier_id?._id;
    }
    if (JSON.stringify(challiValues) !== JSON.stringify(initialData?.loading_challi?.responses)) {
      updatedFields.loading_challi = challiValues;
    }


    if (Object.keys(updatedFields).length === 0) {
      toast.error("No changes detected to update.");
      setTripUpdateLoading(false);
      return;
    }

    const payload = {
      trip_id: tripDetais?._id,
      company_id: StorageService?.getCompanyId(),
      ...updatedFields
    };

    if (validationResult == true) {
      try {

        const res = await updateTripApi(payload)
        if (res?.responseCode == 200) {

          setTripUpdateLoading(false)
          toast?.success(res?.responseMessage || "Update Successfully")
        }
        setTripUpdateLoading(false)

      } catch (error) {
        //  toast?.error(error)
        setTripUpdateLoading(false)
      } finally {
        callApi()
      }
    } else {
      setFormError(validationResult)
      setTripUpdateLoading(false)
    }
  }

  const addNewDriver = () => {
    if (tripOwnerShip == 2) {
      setShowOffcanvasDriver(true)
    } else {
      setShowOffcanvasOwnDriver(true)
    }
  }

  const addNewSupplier = () => {
    if (tripOwnerShip == 2) {
      setShowOffcanvasSupplier(true)
    }
  }


  const callBackDriver = (data) => {
    setForm((pre) => {
      return {
        ...pre,
        driver_id: {
          ...data,
          name: data?.name,
          value: data?._id
        }
      }
    });
    setRefreshKey(prev => prev + 1); // Force refresh
  }


  const callBackSupplier = (data) => {
    setForm((pre) => {
      return {
        ...pre,
        supplier_id: {
          ...data,
          name: data?.name,
          value: data?._id
        }
      }
    });
    setRefreshKey(prev => prev + 1); // Force refresh
  };


  const callBackDataLr = (data) => {
    callApi();
  };

  const handlePermissionCallTrip = async () => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.LR,
      onSuccess: () => {
        setTimeout(() => setSelectParty(true), 0);
      },
      setModalConfig,
    });
  };


  const handlePermissionTrip = async (e, i, index1, addLoad) => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.LR,
      onSuccess: () => {
        // setTimeout(() => getConsignorDetails(e, i, index1, addLoad), 0);
      },
      setModalConfig,
    });
  };


  const apiCallingFunction = async (data) => {
    try {
      const res = await podReceivedData(data);
      if (!!res) {
        setIsOpenPodReceived(false);
        setContinePodReceived(false);
        setLoading(false);
        toast.success(`${res?.responseMessage}`);
        callApi()
      } else {
        setLoading(false);
        setIsOpenPodReceived(false);
        setContinePodReceived(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const closeModalFunction = () => {
    setIsOpenPodReceived(false);
    setContinePodReceived(false);
  }

  const continueOnClickHandler = () => {
    let obj = {
      ...continePodReceived,
      pod_flag: 1
    }
    apiCallingFunction(obj);
  }

  const saveOnClickHandler = () => {
    let obj = {
      ...continePodReceived,
      pod_flag: 0
    }
    apiCallingFunction(obj);
  }

  const submitUpdateData = async (data) => {
    try {
      const res = await podStatusUpdateData(data);
      if (!!res) {
        callApi()
        toast.success(`Update successfully`);
        setLoading(false);
        setIsPodStatusEdit(false);
      } else {
        setLoading(false);
        setIsPodStatusEdit(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const deleteImageFunction = async (data, actionObj) => {
    try {
      let object = {
        lr_id: actionObj?._id,
        file_path: data?.path,
      }
      const res = await deletePodImage(object);
      if (res?.responseCode === 200) {
        setLoading(false);
        if (actionObj?.action === true) {
          // getDetailsOfLrData({ _id: isOpen?._id, company_id: StorageService?.getCompanyId(), })
          toast.success(`POD file deleted successfully`);
          setDeletePodFiles(false)
        }
      }
    } catch (error) {
      setLoading(false);
    }
  }

  const ewayBillHandle = async (e, i) => {
    e.stopPropagation()
    try {
      let object = {
        company_id: StorageService?.getCompanyId(),
        lr_id: i?._id,
      };
      const res = await getDataLrDetails(object);

      if (res?.responseCode === 200) {
        setEwayBillId(res?.data?.lr);
        setEwayForm({
          ...ewayForm,
          start_date: new Date(res?.data?.lr?.eway_bill_date ? res?.data?.lr?.eway_bill_date : new Date()),
          end_date: new Date(res?.data?.lr?.eway_expiry_date ? res?.data?.lr?.eway_expiry_date : new Date()),
          eway_bill_number: res?.data?.lr?.eway_bill_number,
        });
        setEwaybillShow(true);
      }
    } catch (error) {

    }
  };

  const handleChange = async (name, value) => {
    const stateObj = {
      ...ewayForm,
      [name]: value,
    };

    setEwayForm(stateObj);
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        stateObj,
        errorSchema.ewayBillSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleEwayBillUpdate = async () => {
    const validationResult = await utils.checkFormError(
      { ...ewayForm },
      errorSchema.ewayBillSchima
    );
    const payload = {
      lr_id: ewayBillId?._id,
      eway_bill_number: ewayForm?.eway_bill_number,
      eway_bill_date: ewayForm?.start_date,
      eway_expiry_date: ewayForm?.end_date,
    };

    if (validationResult === true) {
      const res = await dispatch(addEwayWill(payload));

      if (res?.payload?.responseCode === 200) {

        callApi()
        setEwayForm({
          ...ewayForm,
          start_date: new Date(),
          end_date: new Date(),
          eway_bill_number: "",
        });
        setEwaybillShow(false);
      } else {
        throw new Error(res?.payload?.responseMessage);
      }
    } else {
      setFormError(validationResult);
    }
  };


  const addPartyWithoutLr = async (prtyData) => {
    try {
      const payload = {
        company_id: StorageService?.getCompanyId() || "",
        trip_id: tripDetais?._id || "",
        consignor_id: prtyData?.party?.value,
        lr_id: ""

      }

      const res = await updateTripApi(payload)
      if (res?.responseCode == 200) {
        toast?.success(res?.responseMessage || "Update Successfully")
        callApi()
      }

    } catch (error) {
      console.error("Submission error:", error);
      // You might want to show an error message to the user here
    } finally {
      // setSubmitLoading(false);
      setSelectParty(false)
      setIsAddLrLater(false)

    }
  };


  const addPartyWithoutLrContinue = async (data) => {
    if (!data?.party) {
      return;
    }

    try {
      let object = {
        consignor_id: data?.party?.value,
        company_id: StorageService.getCompanyId(),
      }
      const res = await fetchConsignorDetailsData(object);
      if (!!res) {


        const fromObj = {
          from_city: data?.from_city?.name,
          from_state: data?.from_city?.stateName,
          lat: data?.from_city?.latitude,
          long: data?.from_city?.longitude
        }
        const toObj = {
          to_city: data?.to_city?.name,
          to_state: data?.to_city?.stateName,
          lat: data?.to_city?.latitude,
          long: data?.to_city?.longitude
        }
        // Extract the party object
        const newParty = {
          consignor_id: {
            ...res?.data?.consignor,
            name: data?.party?.label,
            _id: data?.party?.value,
          },
          from: fromObj,
          from_location: data?.from_city.name,
          from_state: data?.from_city.stateName,
          to_location: data?.to_city.name,
          to_state: data?.to_city.stateName,
          to: toObj,
        };
        setSelectParty(false)
        setIsPickupDrop(false)
      } else {

      }
    } catch (error) {

    } finally {

    }
  }

  const editLrWithParty = () => {
    // setIsAddLrLater(false)
    setSelectParty(true)
  }

  useEffect(() => {
    if (tripDetais?.to_location) {
      // if (!lrId) {
      //   setLrId(consignorTransList[0]?._id);
      // }
      const result = tripDetais?.to_location?.flatMap((item) =>
        item?.lr_list.map((lr) => ({
          consignor_id: lr?.consignor_id?._id,
          lr_id: lr?._id,
        }))
      );

      setSelectedLr(result);

      // if (!lrId) {
      //   if (tripDetais?.to_location) {
      //     const firstLrList = tripDetais?.to_location[0]?.lr_list;

      //     if (firstLrList?.length) {
      //       setLrId(firstLrList[0]?._id);
      //     }
      //   }
      // }
    }
  }, [tripDetais]);

  const callbackSelectLr = async (prtyData, consignor_id) => {

    try {
      const payload = {
        company_id: StorageService?.getCompanyId() || "",
        trip_id: freightId || "",
        consignor_id: consignor_id || "",
        lr_id: prtyData?._id || ""

      }

      const res = await updateTripApi(payload)
      if (res?.responseCode == 200) {
        toast?.success(res?.responseMessage || "Update Successfully")
        callApi()
      }
    } catch (error) {
      console.error("Submission error:", error);
      // You might want to show an error message to the user here
    } finally {
      // setSubmitLoading(false);
      setShowSelectLr(false)
    }
  }

  const deleteLr = (data) => {
    setShowDeleteModal(data)
  }

  const handleDeleteLR = async () => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      trip_id: freightId,
      lr_id: showDeleteModal?._id
    }

    setLoading(true)
    try {

      const res = await deleteLrFromTripApi(payload)

      if (res?.responseCode == 200) {
        callApi()
        setShowDeleteModal(false)
        toast.success(res?.responseMessage || "LR deleted successfully")
      }
    } catch (error) {

    } finally {
      setLoading(false)
    }
  }


  const editLrInTrip = (i) => {
    setShowEditOfcanvas(false)
    handleDetailsAction(i)
  }

  let modalProps = {
    isOpen: isOpenSmallModal,
    closeModal: (e) => setIsOpenSmallModal(false),
    lrId: textState?._id,
    companyId: textState?.company_id,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: submitTestHandle(textState?.lr_status),
    submitTitle: submitTestHandle(textState?.lr_status),
    callBackApiCall: callBackApiCall,
  };

  let makeTruckModal = {
    isOpen: showAvailableTruck,
    closeModal: (e) => setShowAvailableTruck(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Make Truck Available",
    submitTitle: "Mark Available",
  };

  let podRecievedProps = {
    isOpen: isOpenPodReceived,
    closeModal: (e) => setIsOpenPodReceived(false),
    nextModal: (e) => setContinePodReceived(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'POD Received',
    submitTitle: 'POD Received',
    detailsLrData: isOpenPodReceived,
    consignorPermissions: consignorDetailsData,
    deleteImage: (e) => deleteImageFunction(e)
  }

  let continuePodRecievedModalProps = {
    isOpen: continePodReceived,
    closeModal: closeModalFunction,
    modalMainClass: "_dashCommon_Modal _smModal",
    cancelButtonTitle: 'Cancel', // 'Save',
    modalTitle: 'POD Received',
    submitTitle: 'POD Received',
    footerPart: true,
    submitTitle: loading ? 'Loading...' : 'Continue',
    disabled: loading,
    continueOnClick: continueOnClickHandler,
    saveOnClick: closeModalFunction, // saveOnClickHandler,
  }

  let podStatusEditProps = {
    isOpen: isPodStatusEdit,
    closeModal: (e) => setIsPodStatusEdit(false),
    nextModal: (e) => submitUpdateData(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Update POD Status',
    submitTitle: 'Update POD Status',
    consignorPermissions: consignorDetailsData,
    deleteImage: (e) => deleteImageFunction(e, isPodStatusEdit)
  }


  let ewaybillprops = {
    show: ewaybillShow,
    closeModal: (e) => setEwaybillShow(false),
    title: "Update",
    submitTitle: "Update",
    onSubmit: handleEwayBillUpdate,
    icon: images.EDIT,
    isLoadding: ewayLoading,
    disabled: ewayLoading,
  };

  let tripEditProps = {
    isOpen: showEditTrip.isOpen,
    closeModal: (e) => setShowEditTrip((pr) => ({ ...pr, isOpen: false, type: "" })),
    onSubmit: (e) => setShowEditTrip((pr) => ({ ...pr, isOpen: false, type: "" })),
    modalMainClass: " _dashCommon_Modal  _smModal",
    headerPart: true,
    modalTitle: 'Edit Trip',
    submitTitle: "Update",
    tripDetais: tripDetais,
    showEditTrip,
    callApi: callApi,
    // floatCrossBtn: true,
  };

  let selectPartyModal = {
    isOpen: selectParty,
    closeModal: (e) => setSelectParty(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Edit LR",
    submitTitle: "Select LR",
    nextModal: (e) => setShowSelectLr(e),
    showPrefield: showPrefield,
    showingPrefield: (e) => setShowingPrefield(e),
    secondSubmit: addPartyWithoutLr,
    isAddLrLater: isAddLrLater,
    filledLocation: {
      from: { from_city: "dfdgfg " },
      to: { to_city: "shfdghyf" }
    },
    branchFirmIdForTrip: tripDetais.firm_id
  };

  const pickupDropProps = {
    isOpen: isPickupDrop,
    closeModal: (e) => setIsPickupDrop(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Pickup/Drop Location",
    submitTitle: "Create & Add LR Later ",
    nextModal: (e) => setShowAddLR(e),
    secondSubmit: addPartyWithoutLrContinue,
  }
  let selectLrModalProps = {
    isOpen: showSelectLr,
    closeModal: (e) => setShowSelectLr(false),
    onSubmit: (e) => setShowSelectLr(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: " _dashCommon_Modal _xxlModal",
    modalTitle: "Select LR",
    submitTitle: "null",
    setIsSelectLR: setIsSelectLR,
    isSelectLR: isSelectLR,
    // indexofTable: indexofTable,
    // listOfLr: listOfLr,
    callbackSelectLr: callbackSelectLr,
    selectedLr: selectedLr,
    // consignorList: consignorList,
    // branchList: branchList,
    // setSelectParty: setSelectParty,
    tripDetais
  };


  let ebillExpProps = {
    isOpen: modalConfig.isOpen,
    closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
    modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    headerPart: true,
    floatCrossBtn: true,
    submitTitle: "Send Enquiry",
    messageType: modalConfig.messageType,
    templateId: modalConfig.templateId,
    templateData: modalConfig.templateData,

  };

  const deleteModalProps = {
    show: showDeleteModal,
    closeModal: (e) => setShowDeleteModal(false),
    title: "Delete Indent",
    submitTitle: "Confirm",
    onSubmit: handleDeleteLR,
    confirmModal: "confirmModal",
    disabled: loading,
    isLoadding: loading,
  };

  const formatDateToISO = useCallback((date) => {
    if (!date) return "";
    try {
      return new Date(date).toISOString();
    } catch (error) {
      console.error("Date formatting error:", error);
      return "";
    }
  }, []);

  return (
    <>
      <div className=" bg-[#FBF9FB]" style={{ flex: '1' }}>
        <div className="_midCont_body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-10 col-xl-12">
                <div className="_crtDisp_listBx" style={{maxWidth:'1380px', width:'100%'}}>
                  <div className="">
                    <div className="_fleX_inds">
                      <div className="_divForth">


                        <CustomSelect
                          label="Branch"
                          placeholder="Select Branch"
                          options={arryOptions}
                          disabled={true}
                          value={form?.branch_id}
                        />
                        {tripDetais?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565", marginTop: "5px" }}>
                          <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                          {tripDetais?.firm_id?.firm && tripDetais?.firm_id?.firm}
                        </p>}
                      </div>

                      <div className="_divForth">
                        <CommonDatePicker
                          name="dispatch_date"
                          label="Date of Dispatch"
                          startDate={form.dispatch_date}
                          disabled={true}
                        />
                      </div>

                      <div className="_divForth">
                        <CustomSelect
                          label="Route"
                          placeholder="Select Route"
                          options={arryOptions}
                          disabled={true}
                          value={form?.route_name}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <h4 className="_disPatch_heads">Dispatch Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divForth">
                        <CustomSelect
                          label="Vehicle Number"
                          placeholder="Select Vehicle Number"
                          options={arryOptions}
                          disabled={true}
                          value={form?.vehicle_id}
                        />
                        {tripDetais?.vehicle_firm?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565", marginTop: "5px" }}>
                          <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                          {tripDetais?.vehicle_firm?.firm && tripDetais?.vehicle_firm?.firm}
                        </p>}
                      </div>

                      <div className="_divForth">
                        <CustomSelect
                          label="Vehicle Type"
                          placeholder="Select Vehicle Type"
                          options={[{ label: "Vehicle Number", value: "123" }]}
                          disabled={true}
                          value={form?.vehicle_type_id}
                        />
                      </div>

                      {tripDetais?.vehicle_id?.vehicle_ownership == 2 && (
                        <div className="_divForth">

                          <CustomSelect
                            label="Suppler"
                            placeholder="Select Suppler"
                            options={arryOptions}
                            disabled={true}
                            value={form?.supplier_id}
                          />
                          {tripDetais?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565", marginTop: "5px" }}>
                            <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                            {tripDetais?.firm_id?.firm && tripDetais?.firm_id?.firm}
                          </p>}
                        </div>
                      )}

                      {(getOwnerShip == 1 || getOwnerShip == 3 || (driverPermmission == 1 && getOwnerShip == 2)) && (
                        <div className="_divForth">

                          <CustomSelect
                            label="Driver"
                            placeholder="Select Driver"
                            options={arryOptions}
                            disabled={true}
                            value={form?.driver_id}
                          />
                          {tripDetais?.vehicle_firm?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565", marginTop: "5px" }}>
                            <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                            {tripDetais?.vehicle_firm?.firm && tripDetais?.vehicle_firm?.firm}
                          </p>}
                        </div>

                      )}

                      {tripDetais?.interfirm == 1 && <CrossCompanyFreightAlert
                        payableTo={tripDetais?.vehicle_firm?.firm}
                        payableFrom={tripDetais?.firm_id?.firm}
                        value={tripDetais?.firm_freight_summary?.total_freight ? tripDetais?.firm_freight_summary?.total_freight : ""}
                        name="amount"
                        // onChange={handleFreightOnChange}
                        // error={formError?.amount}
                        disabled
                        placeholder="Enter Freight Amount"

                      />}
                    </div>

                  </div>

                  <div className="mb-4">
                    <h4 className="_disPatch_heads">Truck Running Details</h4>
                    <div className="_fleX_inds">
                      <div className="_divForth">
                        <CommonInput
                          type="text"
                          label="Start Kms"
                          name="start_kms"
                          disabled={true}
                          value={Number(form?.start_kms).toFixed(1)}
                        />
                      </div>
                      {tripDetais?.trip_status == (4 || 5) && (
                        <div className="_divForth">
                          <CommonInput
                            type="text"
                            label="End Kms"
                            name="end_kms"
                            disabled={true}
                            value={Number(form?.end_kms).toFixed(1)}
                          />
                        </div>
                      )}
                      {tripDetais?.trip_status == (4 || 5) && (
                        <div className="_divForth">
                          <CommonInput
                            type="text"
                            label="Total Kms"
                            name="total_kms"
                            disabled={true}
                            value={((Number(form?.end_kms) || 0) - (Number(form?.start_kms) || 0)).toFixed(1)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid ">
            <div className="row">
              <h4 className="_disPatch_heads">LR Details</h4>

              <div className="__loadLr_table">
                <table>
                  <thead>
                    <tr>
                      <th>Party Detail</th>
                      <th>From- To Location</th>
                      <th>LR Detail</th>
                      <th>Item Details</th>
                      <th>Eway Details</th>
                      <th>Indent Details</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      listOfLr2?.length ? (
                        <>
                          {listOfLr2 &&
                            listOfLr2.length
                            ? listOfLr2?.map(
                              (i, index1) => {

                                return <>
                                  <tr style={{ cursor: "pointer" }} onClick={(e) => handleDetailsAction(i)} key={index1}>
                                    <td><div className="__dotTxt_1Line"><p>{i?.consignor_id?.name || ""}</p></div></td>
                                    <td>
                                      <div className='mb-1'>
                                        <p>{i?.from?.from_city || ""}</p>
                                        {i?.unit_id
                                          ?.name ? <span>
                                          {i?.unit_id
                                            ?.code
                                            && i?.unit_id
                                              ?.code
                                          }{" "}
                                          {(i?.unit_id
                                            ?.code && i?.unit_id
                                              ?.name) && "-"}
                                          {i?.unit_id
                                            ?.code && i?.unit_id
                                              ?.name ? " | " : ""}
                                          {i?.unit_id
                                            ?.name
                                            ? i?.unit_id
                                              ?.name
                                            : " -"}
                                        </span> : <button className='__adxConsignee' onClick={(e) => getConsignorDetails(e, i, index1, "unit")} disabled={consignorLoading[`unit_${index1}`]}>{consignorLoading[`unit_${index1}`] ? "Adding Unit.." : "Add Unit"}</button>}
                                        <span> {i?.unit_id?.zone_id?.name ? `Zone - ${i?.unit_id?.zone_id?.name}` : ""}</span>
                                      </div>

                                      <div>
                                        <p>{i?.to?.to_city || ""}</p>
                                        {i?.consignee_id
                                          ?.name ? <span>{i?.consignee_id
                                            ?.code
                                            && i?.consignee_id
                                              ?.code
                                          }{" "}
                                          {(i?.consignee_id
                                            ?.code && i?.consignee_id
                                              ?.name) && "-"}
                                          {i?.consignee_id
                                            ?.code && i?.consignee_id
                                              ?.name ? " | " : ""}
                                          {i?.consignee_id
                                            ?.name
                                            ? i?.consignee_id
                                              ?.name
                                            : " -"}</span> : <button className='__adxConsignee' onClick={(e) => getConsignorDetails(e, i, index1, "consignee")} disabled={consignorLoading[`consignee_${index1}`]}>{consignorLoading[`consignee_${index1}`] ? "Adding Consignee.." : "Add Consignee"}</button>}
                                        <span>{i?.consignee_id?.zone_id?.name ? `Zone - ${i?.consignee_id?.zone_id?.name}` : ""}</span>
                                      </div>
                                    </td>
                                    <td>
                                      {i?.lr_number || i?.invoice_number || i?.invoice_date || i?.mlr_number ? <div className='__lrDetail_lodFx'>
                                        <div className='__lrDetail_lodInr'>
                                          <span>LR Date</span>
                                          <p>{i?.invoice_date ? moment(
                                            i?.invoice_date
                                          ).format(
                                            " DD/MM/YYYY"
                                          ) : "-"}</p>
                                        </div>
                                        <div className='__lrDetail_lodInr'>
                                          <span>Invoice Number</span>
                                          <p onClick={(e) =>
                                            i?.invoice_number && handleDetailsAction(
                                              i, index1
                                            )
                                          }> {i?.invoice_number
                                            ? i?.invoice_number
                                            : "-"}</p>
                                        </div>
                                        <div className='__lrDetail_lodInr'>
                                          <span>LR Number</span>
                                          <p onClick={(e) =>
                                            i?.lr_number && handleDetailsAction(
                                              i, index1
                                            )
                                          }>{i?.lr_number
                                            ? `${i?.lr_number}`
                                            : "-"}</p>
                                        </div>
                                        <div className='__lrDetail_lodInr'>
                                          <span>MLR Number</span>
                                          <p onClick={(e) =>
                                            i?.mlr_number && handleDetailsAction(
                                              i, index1
                                            )
                                          }>{i?.mlr_number
                                            ? `${i?.mlr_number}`
                                            : "-"}</p>
                                        </div>
                                      </div> : <button className='__advLr_btn' onClick={(e) => handlePermissionTrip(e, i, index1, "addLoad")} disabled={consignorLoading[`addLoad_${index1}`]}>
                                        {consignorLoading[`addLoad_${index1}`] ? "Load Data..." : "Add Load Details"}
                                        {i?.consignor_id?.permission_at_dispatch?.lr_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>}
                                    </td>
                                    <td>
                                      {i?.lr_material_list?.length > 0 ? <>
                                        <div className='d-flex mb-1'>
                                          <span style={{ flex: '0 0 90px' }}>KOT</span>
                                          <p>{utils.getTotalAmount(i?.lr_material_list, 'kot')}</p>
                                        </div>
                                        <div className='d-flex mb-1'>
                                          <span style={{ flex: '0 0 90px' }}>QTY</span>
                                          <p>{utils.getTotalAmount(i?.lr_material_list, 'qty')}</p>
                                        </div>
                                        <div className='d-flex mb-1'>
                                          <span style={{ flex: '0 0 90px' }}>Sales Value</span>
                                          <p>{utils.getTotalAmount(i?.lr_material_list, 'amount')}</p>
                                        </div>
                                        <div className='d-flex'>
                                          <span style={{ flex: '0 0 90px' }}>Weight</span>
                                          <p>
                                            {utils.getTotalAmount(i?.lr_material_list, 'weight')}{' '}
                                            {
                                              masterData?.material_weight_type[i?.lr_material_list[index1]?.weight_type]
                                            }
                                          </p>
                                        </div>
                                      </> :
                                        <button className='__advLr_btn' onClick={(e) => handlePermissionTrip(e, i, index1, "additem")} disabled={consignorLoading[`additem_${index1}`]}>
                                          {consignorLoading[`additem_${index1}`] ? "Load Data..." : "Add Item Details"} {i?.consignor_id?.permission_at_item?.item?.mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>

                                      }
                                    </td>
                                    <td>
                                      {i.eway_bill_number !== undefined ? <><div className='mb-2'>
                                        <span>Eway Number (Manual)</span>

                                        {i?.eway_bill_number != null ? <p>{i?.eway_bill_number || ""}</p> : <button
                                          className="__adxConsignee"
                                          onClick={(e) =>
                                            ewayBillHandle(e,
                                              i
                                            )
                                          }
                                        >
                                          + Add Eway
                                          Bill
                                          {i?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>}
                                      </div>
                                        <div>
                                          <span>Expiry Date</span>
                                          <p>{i?.eway_expiry_date ? moment(
                                            i?.eway_expiry_date
                                          ).format(
                                            " DD/MM/YYYY"
                                          ) : "-"}</p>
                                        </div></> : <button className='__advLr_btn' onClick={(e) => getConsignorDetails(e, i, index1, "Eway")} disabled={consignorLoading[`Eway_${index1}`]}>
                                        {consignorLoading[`Eway_${index1}`] ? "Load Data..." : "Add Eway Bill"}
                                        {i?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>
                                      }

                                    </td>
                                    <td>
                                      {i?.indent_number || i?.po_number ? <>
                                        <div className='mb-2'>
                                          {i?.indent_number && <span>Indent Number</span>}
                                          <p>{i?.indent_number ? `#${i?.indent_number || ""}` : "-"}</p>
                                        </div>
                                        <div>
                                          {i?.po_number && <span>PO Number</span>}
                                          <p>{i?.po_number || "-"}</p>
                                        </div>
                                      </> : <span style={{ textAlign: "center" }} >{"-"}</span>}
                                    </td>
                                  </tr>

                                  <tr className="__podPend_bx">
                                    <td colSpan={6}>
                                      <div className="__flxrPods">
                                        <div className="PickNdrop_placeBx">
                                          <div className="_cnFr_listsBx">
                                            {(i?.pod_status === 1 && i?.lr_status >= 3) && <div className="_inrPd">
                                              <h4>POD Pending</h4>
                                              <button className="__adnPo_btn" onClick={(e) => setIsOpenPodReceived({ ...i })}>+ Add POD</button>
                                            </div>}

                                            {i?.pod_status > 1 && <div className="_inrPd">
                                              <h4>POD Received</h4>
                                              {i?.pod_file?.length > 0 && <button className="__adnPo_btn" onClick={(e) => setIsPodStatusEdit({ ...i })}>View ({i?.pod_file?.length})</button>}
                                            </div>}

                                            <div className="_td_rightPt">
                                              {tripDetais?.trip_status != 5 && <div className="_td_lrsCommon">
                                                {i?.lr_process?.length >
                                                  0 &&
                                                  i?.lr_process?.map(
                                                    (k, index) => {
                                                      return (
                                                        <div
                                                          className={`_td_stepsBx ${k?.status === 1
                                                            ? "_td_stepsBx_active"
                                                            : ""
                                                            }`}
                                                          key={index}
                                                        >
                                                          <div className="_td_stepIcon">
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="21"
                                                              height="21"
                                                              viewBox="0 0 17 17"
                                                              fill="none"
                                                            >
                                                              <circle
                                                                cx="8.1076"
                                                                cy="8.1076"
                                                                r="8.1076"
                                                                fill="#D9D9D9"
                                                              ></circle>
                                                              <path
                                                                d="M3.47461 7.722L6.5637 10.8111L12.7404 4.6329"
                                                                stroke="#828282"
                                                                strokeWidth="1.45609"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                              ></path>
                                                            </svg>
                                                          </div>

                                                          <div className="_td_stepInfos">
                                                            <p>
                                                              {" "}
                                                              {k?.name}
                                                            </p>
                                                            <span>
                                                              {k?.status ===
                                                                1
                                                                ? utils.formatDateMonth(
                                                                  k?.date
                                                                )
                                                                : ""}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                              </div>}
                                              {tripDetais?.trip_status != 5 ? <button
                                                disabled={i?.lr_status == 6}
                                                className="_atPr_point"
                                                onClick={() => {
                                                  handleButtonClick(i, tripDetais);
                                                }}
                                              >
                                                {handleButtonText(
                                                  i?.lr_status
                                                )}

                                              </button> : <button className=" _atPr_point cancelled_lr" disabled>Cancelled</button>}
                                            </div>
                                          </div>
                                        </div>
                                        <button
                                          className="closeTble_btn"
                                          type="button"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="56"
                                            height="29"
                                            viewBox="0 0 56 29"
                                            fill="none"
                                          >
                                            <rect
                                              x="56"
                                              y="29"
                                              width="56"
                                              height="29"
                                              rx="14.5"
                                              transform="rotate(180 56 29)"
                                              fill="#434343"
                                            />
                                            <path
                                              d="M41.9806 10.2104C41.9162 10.1458 41.8396 10.0946 41.7554 10.0596C41.6711 10.0247 41.5807 10.0067 41.4895 10.0067C41.3983 10.0067 41.3079 10.0247 41.2237 10.0596C41.1394 10.0946 41.0629 10.1458 40.9984 10.2104L37.592 13.6098L34.1856 10.2034C34.1211 10.1389 34.0446 10.0878 33.9603 10.0529C33.876 10.018 33.7857 10 33.6945 10C33.6033 10 33.513 10.018 33.4287 10.0529C33.3445 10.0878 33.2679 10.1389 33.2034 10.2034C33.1389 10.2679 33.0878 10.3445 33.0529 10.4287C33.018 10.513 33 10.6033 33 10.6945C33 10.7857 33.018 10.876 33.0529 10.9603C33.0878 11.0446 33.1389 11.1211 33.2034 11.1856L36.6098 14.592L33.2034 17.9984C33.1389 18.0629 33.0878 18.1395 33.0529 18.2237C33.018 18.308 33 18.3983 33 18.4895C33 18.5807 33.018 18.671 33.0529 18.7553C33.0878 18.8396 33.1389 18.9161 33.2034 18.9806C33.2679 19.0451 33.3445 19.0963 33.4287 19.1312C33.513 19.1661 33.6033 19.184 33.6945 19.184C33.7857 19.184 33.876 19.1661 33.9603 19.1312C34.0446 19.0963 34.1211 19.0451 34.1856 18.9806L37.592 15.5742L40.9984 18.9806C41.0629 19.0451 41.1395 19.0963 41.2237 19.1312C41.308 19.1661 41.3983 19.184 41.4895 19.184C41.5807 19.184 41.671 19.1661 41.7553 19.1312C41.8396 19.0963 41.9161 19.0451 41.9806 18.9806C42.0451 18.9161 42.0963 18.8396 42.1312 18.7553C42.1661 18.671 42.184 18.5807 42.184 18.4895C42.184 18.3983 42.1661 18.308 42.1312 18.2237C42.0963 18.1395 42.0451 18.0629 41.9806 17.9984L38.5742 14.592L41.9806 11.1856C42.2453 10.9209 42.2453 10.4751 41.9806 10.2104Z"
                                              fill="white"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              }
                            )
                            : <tr></tr>}
                        </>
                      ) : (
                        ""
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

{console.log(challiValues)}

          {tripDetais?.branch_id?.loading_challi?.view == 1 && <div className="container-fluid pt-5">
            <div style={{ display: "flex", gap: "10px", alignContent: "center" }} >
              <h4 className="_disPatch_heads mb-2">Loading Challi </h4><span style={{ display: "flex", gap: "10px", alignContent: "center", fontSize: "15px", marginTop: "2px" }}> Total Qty : {challiValues[20]}</span>
              {/* <img src={Images?.EDIT} className=" mb-2" onClick={editLoadChali} style={{ cursor: "pointer" }} /> */}
            </div>

            <LoadingChalli values={challiValues}
              onChange={handleChalliChange} mandatory={tripDetais?.branch_id?.loading_challi?.mandatory} disabled={isDisabled} />

          </div>}
          {!!formError.loadingChalli && (
            <div style={{ color: "red", fontSize: 12, marginTop: 4, fontWeight: 500 }}>
              {formError.loadingChalli}
            </div>
          )}


        </div>

      </div>

      {/* <div className="bottomFix chaliBtnBx">
        <button
          className="_addComm_btn"
          type="button"
          onClick={() => {
            setShowEditOfcanvas(true)
            
          }}
          disabled={tripUpdateLoading}
        >
        
          Edit
        </button>

        <button className="_cancel_btn" type="button" onClick={() => {
          callApi()
          setIsDisabled(true)
          navigate("/trip/addtrip")
        }}>
          Cancel
        </button>
      </div> */}


      {isOpenSmallModal && <AtPartyPointModal {...modalProps} />}
      {showAvailableTruck && <MakeTruckAvailableModal {...makeTruckModal} />}
      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? "visible" : "hidden" }}
      >
        {showLrDetail && (
          <LrDetailModal
            isOpen={showLrDetail}
            onClose={(e) => setShowLrDetail(false)}
            nextModal={(e) => handleNextModal(e)}
          />
        )}
      </div>
      <div className={showLrDetail ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showAddLR ? "visible" : "hidden" }}
      >
        {showAddLR && (
          <AddEditLrModal
            isOpen={showAddLR}
            onClose={() => setShowAddLR(false)}
            callBackDataLr={callBackDataLr}
            type="from_trip"
            callGetData={() => { }}
          />
        )}
      </div>
      <div className={showAddLR ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasDriver ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasDriver ? "visible" : "hidden" }}
      >
        {showOffcanvasDriver && (
          <AddEditMarketDriver
            isOpen={showOffcanvasDriver}
            onClose={() => {
              setShowOffcanvasDriver(false);
            }}
            callBackDriver={callBackDriver}
            hideAddNewOption={false}
          />
        )}
      </div>

      <div className={showOffcanvasDriver ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOwnDriver ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasOwnDriver ? "visible" : "hidden" }}
      >
        {showOffcanvasOwnDriver && (
          <AddEditOwnDriver
            isOpen={showOffcanvasOwnDriver}
            onClose={() => {
              setShowOffcanvasOwnDriver(false);
            }}
            callBackDriver={callBackDriver}
            hideAddNewOption={false}
          />
        )}
      </div>

      <div className={showOffcanvasOwnDriver ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasSupplier ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasSupplier ? "visible" : "hidden" }}
      >
        {showOffcanvasSupplier && (
          <AddEditSupplier
            isOpen={showOffcanvasSupplier}
            onClose={() => setShowOffcanvasSupplier(false)}
            callBackSupplier={callBackSupplier}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div className={showOffcanvasSupplier ? "offBack_drop" : ""}></div>

      {
        isOpenPodReceived?._id
        && (
          <PodRecievedModal {...podRecievedProps} />
        )
      }

      {
        continePodReceived?.date
        && (
          <ContinuePodRecievedModal {...continuePodRecievedModalProps} />
        )
      }

      {
        isPodStatusEdit?._id
        && (
          <EditPodStatus {...podStatusEditProps} />
        )
      }

      {ewaybillShow && (
        <ConfirmModalFor {...ewaybillprops}>
          <>
            <div className="colFlx">
              <div className="_addRouts_flex">
                <CommonDatePicker
                  name="dispatch_date"
                  label="Date of Dispatch"
                  startDate={ewayForm?.start_date}
                  setStartDate={(data) => {
                    handleChange("start_date", data);
                  }}
                  error={formError?.start_date}
                  focus={formError?.start_date}
                />
                <CommonDatePicker
                  name="dispatch_date"
                  label="Date of Dispatch"
                  startDate={ewayForm?.end_date}
                  setStartDate={(data) => {
                    handleChange("end_date", data);
                  }}
                  error={formError?.end_date}
                  focus={formError?.end_date}
                />
              </div>
              <CommonInput
                label="Eway bill number"
                placeholder="Enter Number"
                name="eway_bill_number"
                onChange={({ target: { name, value } }) =>
                  handleChange(name, value)
                }
                maxLength={12}
                value={ewayForm?.eway_bill_number}
                onKeyDown={handleKeyDown}
                error={formError?.eway_bill_number}
                focus={formError?.eway_bill_number}
              />
            </div>
          </>
        </ConfirmModalFor>
      )}
      <div className={`offcanvas offcanvas-end common_offCanvas ${showOffEditOfcanvas ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffEditOfcanvas ? 'visible' : 'hidden' }}
      >
        {showOffEditOfcanvas &&
          <EditTripOffCanvas
            isOpen={showOffEditOfcanvas}
            onClose={(e) => setShowEditOfcanvas(false)}
            setShowEditTrip={setShowEditTrip}
            tripDetais={tripDetais}
            editLrWithParty={editLrWithParty}
            deleteLr={deleteLr}
            editLrInTrip={editLrInTrip}
          />
        }
      </div>
      <div className={showOffEditOfcanvas ? 'offBack_drop' : ''}></div>

      {showEditTrip.isOpen && <EditTripModal {...tripEditProps} />}

      {selectParty && <AddLrModal {...selectPartyModal} />}
      {isPickupDrop && <AddPickUpDrop {...pickupDropProps} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? "visible" : "hidden" }}
      >
        {isAddConsignor && (
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            isPreviousModal={(e) => setSelectParty(true)}
            showingPrefield={(e) => setShowingPrefield(true)}
            hideAddNewOption={false}
            branchFirmId={tripDetais?.firm_id?._id}
          />
        )}
      </div>

      <div className={isAddConsignor ? "offBack_drop" : ""}></div>

      {modalConfig.isOpen && <EbillExtentionModal

        {...ebillExpProps}

      />}

      {showSelectLr && <SelectLrForConsignor {...selectLrModalProps} />}

      {showDeleteModal && (
        <ConfirmModalFor {...deleteModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want Delete indent </p>
          </>
        </ConfirmModalFor>
      )}

    </>
  );
};

export default DispatchDetails;
